import React, { memo, useCallback } from 'react';

import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { copyToClipboard } from 'utils/copyToClipboard';

import { AiChatTestIds } from '../../AiChat.testIds';
import MessageTools, { MESSAGE_TOOLS_CLASS_NAME } from '../MessageTools';

import UserMessageAvatar from './components/UserMessageAvatar';
import {
  containerStyles,
  contentWrapperStyles,
  messageContentStyles,
  messageToolsHiddenStyles,
} from './UserMessage.styles';

const UserMessage = ({ message, userId, displayName, isShownTools = true }) => {
  const { content, timestamp } = message;

  const handleCopy = useCallback(() => {
    copyToClipboard(content);
  }, [content]);

  return (
    <Box data-testid={AiChatTestIds.USER_MESSAGE} sx={containerStyles}>
      <UserMessageAvatar displayName={displayName} userId={userId} />
      <Box sx={contentWrapperStyles}>
        <Box data-testid={AiChatTestIds.USER_MESSAGE_CONTENT} sx={messageContentStyles}>
          <Typography variant="regular14">{content}</Typography>
        </Box>
        {isShownTools && (
          <MessageTools
            className={MESSAGE_TOOLS_CLASS_NAME}
            data-testid={AiChatTestIds.USER_MESSAGE_TOOLS}
            justifyContent="flex-end"
            sx={messageToolsHiddenStyles}
            timestamp={timestamp}
            onCopy={handleCopy}
          />
        )}
      </Box>
    </Box>
  );
};

UserMessage.propTypes = {
  message: PropTypes.shape({
    content: PropTypes.string.isRequired,
    id: PropTypes.string,
    timestamp: PropTypes.string,
    status: PropTypes.string,
  }).isRequired,
  userId: PropTypes.string,
  displayName: PropTypes.string,
  isShownTools: PropTypes.bool,
};

export default memo(UserMessage);
